/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Tipo de contrato: Autónomo, De duración determinada, De relevo, Fijo discontinuo, Indefinido, A tiempo Parcial, Otros Contratos
 * @export
 * @interface ContractType
 */
export interface ContractType {
    /**
     * 
     * @type {number}
     * @memberof ContractType
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractType
     */
    name?: string;
}

export function ContractTypeFromJSON(json: any): ContractType {
    return ContractTypeFromJSONTyped(json, false);
}

export function ContractTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ContractTypeToJSON(value?: ContractType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


